<div class="orgApp-justify-c-spc-btw orgApp-d-flex orgApp-flex-dir-row">
  <div class="orgApp-d-flex">
    <svg width="16" height="16" viewBox="0 0 20 20">
      <use [attr.xlink:href]="'#toast-'+ data.icon + '-' + data.color"></use>
    </svg>
    <div
      class="data toast-content" [ngStyle]="{ width: data.width ? data.width : '184px',padding: data.padding ? data.padding:'' }"
      >
      <!-- Main error message -->
      <div [innerHtml]="data.message | translate:{ param: data?.traceId, value: data?.user, url: data?.url }">
      </div>
      <!-- TraceId shown only if available -->
       @if (data?.traceId) {
      <div class="trace-id">
        Trace ID: {{ data.traceId }}
      </div>
      }
    </div>
  </div>
  <label
    class="close-label"
    for="closeSnackbar"
    (click)="snackBarRef.dismiss()"
    onKeyPress=""
    onKeyDown=""
    onKeyUp=""
    >{{ "close" }}</label
  >
</div>
